import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
    gAPI_Twilio_Templates,
    postAPI_Add_OutboundTriggerAction,
    gAPI_OutboundTriggerAction_By_TriggerId
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';

const PRIORITY_OPTIONS = [
    { label: 'Priority 1', value: 1 },
    { label: 'Priority 2', value: 2 },
    { label: 'Priority 3', value: 3 },
];

const CHANNEL_OPTIONS = [
    { label: 'SMS', value: 'SMS' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Email', value: 'Email' },
];

export function TriggerAction({ visible, toggle, triggerId, LoadData, propertyId, triggerStatus }) {

    const [actions, setActions] = useState([

        {
            id: null,
            priority: '',
            channel: '',
            templateId: '',
        }
    ]);
    const [allTemplates, setAllTemplates] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);


    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
        })
            .then((res) => {
                const templates = res.data || [];
                setAllTemplates(templates);

            })
            .catch((err) => console.error(err));
    }, [propertyId]);

    const getTemplateBodyById = (templateId) => {
        if (!templateId || !allTemplates.length) return '';

        const template = allTemplates.find(t => t.id === templateId);
        return template?.templateBody || '';
    };


    useEffect(() => {
        if (!visible || !triggerId) return;

        AxiosAPI({
            method: 'get',
            url: `${gAPI_OutboundTriggerAction_By_TriggerId}?triggerId=${triggerId}`,
        })
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];

                setActions(
                    data.length
                        ? data.map(item => ({
                            id: item.id,
                            priority: item.priority,
                            channel: item.channel,
                            templateId: item.templateId,

                        }))
                        : [{
                            id: null,
                            priority: '',
                            channel: '',
                            templateId: '',

                        }]
                );
            })
            .catch(console.error);
    }, [visible, triggerId]);


    const getTemplatesByChannel = (selectedChannel) => {
        if (!Array.isArray(allTemplates)) return [];

        return allTemplates.filter(
            (tpl) =>
                Array.isArray(tpl.channel) &&
                tpl.channel.includes(selectedChannel)
        );
    };


    const handlePriorityChange = (index, value) => {
        const updated = [...actions];
        updated[index].priority = Number(value);
        setActions(updated);
    };

    const handleChannelChange = (index, channel) => {
        const updated = [...actions];
        updated[index].channel = channel;
        updated[index].templateId = '';
        updated[index].previewText = '';
        setActions(updated);
    };

    const handleTemplateChange = (index, templateId) => {
        const updated = [...actions];
        updated[index].templateId = templateId;
        setActions(updated);
    };

    console.log("action", actions)


    const handleAddAction = () => {
        setActions(prev => [
            ...prev,
            {
                id: null,
                priority: '',
                channel: '',
                templateId: '',
            }
        ]);
    };

    const handleRemoveAction = (index) => {
        if (index === 0) return;
        setActions(actions.filter((_, i) => i !== index));
    };


    const handleSubmit = () => {
        const body = {
            triggerId,
            status: triggerStatus,
            actions: actions.map(a => ({
                ...(a.id ? { id: a.id } : {}),
                priority: a.priority,
                channel: a.channel,
                templateId: a.templateId,
            })),
            createdBy: 'dashboard',
            UpdatedBy: "dashboard"
        };
        console.log("body", body)

        AxiosAPI({
            method: 'post',
            url: postAPI_Add_OutboundTriggerAction,
            data: body,
        })
            .then((res) => {
                console.log(res.data)
                if (
                    res.data?.HttpStatusCode === 400 &&
                    res.data?.Messages?.length
                ) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                } else {
                    toggle();
                    LoadData();
                }
            })
            .catch((err) => console.error(err));
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    Add Trigger Actions
                </ModalHeader>

                <ModalBody>
                    {actions.map((action, index) => (
                        <Fragment key={index}>

                            {/* DROPDOWN ROW */}
                            <Row className="mb-3 align-items-center">

                                {/* Priority */}
                                <Colxx xxs="3">
                                    <Input
                                        type="select"
                                        value={action.priority}
                                        onChange={(e) =>
                                            handlePriorityChange(index, e.target.value)
                                        }
                                    >
                                        <option value="">Select Priority</option>
                                        {PRIORITY_OPTIONS.map((p) => (
                                            <option
                                                key={p.value}
                                                value={p.value}
                                            >
                                                {p.label}
                                            </option>
                                        ))}
                                    </Input>
                                </Colxx>

                                {/* Channel */}
                                <Colxx xxs="4">
                                    <Input
                                        type="select"
                                        value={action.channel}
                                        onChange={(e) =>
                                            handleChannelChange(index, e.target.value)
                                        }
                                    >
                                        <option value="">Select Channel</option>
                                        {CHANNEL_OPTIONS.map((ch) => (
                                            <option key={ch.value} value={ch.value}>
                                                {ch.label}
                                            </option>
                                        ))}
                                    </Input>
                                </Colxx>

                                {/* Template */}
                                <Colxx xxs="4">
                                    <Input
                                        type="select"
                                        disabled={!action.channel}
                                        value={action.templateId}
                                        onChange={(e) => handleTemplateChange(index, e.target.value)}
                                    >
                                        <option value="">Select Template</option>

                                        {getTemplatesByChannel(action.channel).map((tpl) => (
                                            <option key={tpl.id} value={tpl.id}>
                                                {tpl.name}
                                            </option>
                                        ))}
                                    </Input>

                                </Colxx>

                                {/* Remove */}
                                <Colxx xxs="1" className="text-center">
                                    {index > 0 && (
                                        <Button
                                            color="danger"
                                            outline
                                            onClick={() => handleRemoveAction(index)}
                                        >
                                            −
                                        </Button>
                                    )}
                                </Colxx>
                            </Row>

                            {/* PREVIEW TEXTAREA */}
                            <Label>Preview</Label>
                            <Input
                                type="textarea"
                                className='mb-3'
                                rows="4"
                                readOnly
                                value={getTemplateBodyById(action.templateId)}
                                placeholder="Message preview will appear here"
                            />


                        </Fragment>
                    ))}

                    <Button color="primary" outline onClick={handleAddAction}>
                        + Add Action
                    </Button>
                </ModalBody>

                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Create
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Validation
                open={open}
                messages={msg}
                toggle={() => setOpen(!open)}
            />
        </Fragment>
    );
}
